import { TEACHER_POSITION_SHORT_FORMS } from '../constants/teacherPositions';

// Abbreviates the academic titles that have a customary short form. The field is free text, so
// anything else is shown as written rather than dropped — an unknown title used to reach the
// schedule cell as the string "undefined".
export const parseShortPosition = (position) => {
    if (!position) {
        return '';
    }
    return TEACHER_POSITION_SHORT_FORMS.get(position.toLowerCase()) ?? position;
};
export const getFirstLetter = (word) => {
    return word !== null ? `${word.charAt(0)}.` : '';
};
export const getTeacherName = (teacher) => {
    const { name, surname, patronymic } = teacher;
    return `${surname} ${getFirstLetter(name)} ${getFirstLetter(patronymic)}`;
};
export const getTeacherFullName = (teacher) => {
    const { name, surname, patronymic } = teacher;
    return `${surname} ${name} ${patronymic}`;
};
export const getTeacherForSite = (teacher) => {
    const { name, surname, patronymic, position } = teacher;
    return `${position} ${surname} ${getFirstLetter(name)} ${getFirstLetter(patronymic)}\n`;
};
export const handleTeacherInfo = (teacher) => {
    const { name, surname, patronymic, position } = teacher;
    if (position) {
        return `${surname} ${name} ${patronymic} (${position})`;
    }
    return `${surname} ${name} ${patronymic}`;
};
export const getTeacherWithPosition = (teacher) => {
    const { name, surname, patronymic, position } = teacher;
    return `${position} ${surname} ${name} ${patronymic}`;
};

export const getTeacherWithShortPosition = (teacher) => {
    const { name, surname, patronymic, position } = teacher;
    return `${parseShortPosition(position)} ${surname} ${name} ${patronymic}`;
};
